var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"cloudChartContainer",staticClass:"py-5"},[(Object.keys(_vm.chartData).length)?_c('highcharts',{ref:"cloudChart",attrs:{"options":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }